var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "material-pages-wrapper us-pages-wrapper"
  }, [_c('website-header', {
    staticStyle: {
      "position": "absolute"
    }
  }), _vm._v(" "), _c('Content')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };